import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { createCategoriaKae } from "../../../../services";
import { withRouter } from "../../../../providers/withRouter";

const NuevaCategoria = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [categoria, setCategoria] = useState({});

  function handleSubmit(data) {
    const toastInfo = toast.info(t('categories.messages.saving'));
    let errores = false;

    if (!data.nombre || !data.nombre.trim()) {
      toast.dismiss(toastInfo);
      toast.error(t('categories.messages.fieldRequired', { field: t('categories.columns.name') }));
      errores = true;
    }

    if (!data.descripcion || !data.descripcion.trim()) {
      toast.dismiss(toastInfo);
      toast.error(t('categories.messages.fieldRequired', { field: t('categories.columns.description') }));
      errores = true;
    }

    if (!errores) {
      createCategoriaKae(data)
        .then((res) => {
          if (res.status === 201) {
            toast.update(toastInfo, {
              render: t('categories.messages.created'),
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
            navigate("/categorias");
          } else {
            toast.update(toastInfo, {
              render: t('categories.messages.createError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          toast.error(t('categories.messages.createError'));
        });
    }
  }

  function handleChange(evt) {
    const value = evt.target.value;
    setCategoria({
      ...categoria,
      [evt.target.name]: value,
    });
  }

  return (
    <>
      <BreadCrumb
        rutas={[
          { path: "/categorias", label: t('categories.title') },
          { path: "/categorias/nueva", label: t('categories.new') },
        ]}
        style={{ margin: "0 10px" }}
      />
      <div className="pageContent">
        <div className="gridHead">
          {t('categories.createNew')}
        </div>
        <form className="nuevoAAFFForm">
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20, padding: "0 20px" }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('categories.columns.name')}
                name="nombre"
                value={categoria.nombre || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('categories.columns.description')}
                name="descripcion"
                value={categoria.descripcion || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid style={{ display: "flex", justifyContent: "end", padding: 20 }}>
            <input
              type="button"
              value={t('actions.save')}
              onClick={() => handleSubmit(categoria)}
            />
          </Grid>
        </form>
      </div>
    </>
  );
};

export default withRouter(NuevaCategoria);
